module.exports = __webpack_public_path__ + "static/media/pasos.99e66efa.svg";